var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIconMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4861 1.21065C11.8472 0.929784 12.3528 0.929784 12.7139 1.21065L21.7139 8.21065C21.9575 8.4001 22.1 8.69141 22.1 9V20C22.1 20.7957 21.7839 21.5587 21.2213 22.1213C20.6587 22.6839 19.8957 23 19.1 23H5.10001C4.30436 23 3.54129 22.6839 2.97869 22.1213C2.41608 21.5587 2.10001 20.7957 2.10001 20V9C2.10001 8.69141 2.24248 8.4001 2.48607 8.21065L11.4861 1.21065ZM4.10001 9.48908V20C4.10001 20.2652 4.20536 20.5196 4.3929 20.7071C4.58044 20.8946 4.83479 21 5.10001 21H19.1C19.3652 21 19.6196 20.8946 19.8071 20.7071C19.9946 20.5196 20.1 20.2652 20.1 20V9.48908L12.1 3.26686L4.10001 9.48908Z",
    fill: "#676D75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.10001 12C8.10001 11.4477 8.54772 11 9.10001 11H15.1C15.6523 11 16.1 11.4477 16.1 12V22C16.1 22.5523 15.6523 23 15.1 23C14.5477 23 14.1 22.5523 14.1 22V13H10.1V22C10.1 22.5523 9.65229 23 9.10001 23C8.54772 23 8.10001 22.5523 8.10001 22V12Z",
    fill: "#676D75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconMenu);
export default __webpack_public_path__ + "static/media/home-icon-menu.55a670eb6c868aee370c74c3b22be771.svg";
export { ForwardRef as ReactComponent };